<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="titlePage" id="tit01">
<a id="page01"></a>
<a id="page03"></a>
<h2 class="titlePageAuthor"><span class="bold">BEN WEAVER</span></h2>
<h2 class="titlePageTitle"><span class="bold">PATRIOTS IN ARMS</span></h2>
<p class="titleimage"><img alt="logo" src="logo.jpg"/></p>
</div>
<div class="dedicationPage" id="ded01">
<a id="page05"></a>
<p class="dedicationText"><em class="italic">For all those who have ever been <br/>Brothers, Rebels, and Patriots…</em></p>
</div>
<div class="contents" id="con4">
<h2 class="contentsHead"><span class="bold">Contents</span></h2>
<div class="contentsEntry" id="pt_01"><p class="contentsEntryNumber"><a href="#/part01#pt01">
PART 1</a></p>
<p class="contentsEntryName">Heavy Losses</p></div>
<div class="contentsEntry" id="ch_01"><p class="contentsEntryNumber"><a href="#/chapter01#ch01">
1</a></p>
<p class="contentsEntryName">The news reports all that morning had focused on the…</p></div>
<div class="contentsEntry" id="ch_02"><p class="contentsEntryNumber"><a href="#/chapter02#ch02">
2</a></p>
<p class="contentsEntryName">“I’m still alive,” Halitov said over my private channel. “I…</p></div>
<div class="contentsEntry" id="ch_03"><p class="contentsEntryNumber"><span href="#/chapter03#ch03" title="Link target outside of Sample">
3</span></p>
<p class="contentsEntryName">Clearly, Ms. Elise Rainey had trouble with the damsel in…</p></div>
<div class="contentsEntry" id="ch_04"><p class="contentsEntryNumber"><span href="#/chapter04#ch04" title="Link target outside of Sample">
4</span></p>
<p class="contentsEntryName">Lieutenant Colonel Jean Sheffield, our regimental executive officer, entered the…</p></div>
<div class="contentsEntry" id="ch_05"><p class="contentsEntryNumber"><span href="#/chapter05#ch05" title="Link target outside of Sample">
5</span></p>
<p class="contentsEntryName">Halitov looked as dumbfounded as Ms. Brooks and the colonel.…</p></div>
<div class="contentsEntry" id="ch_06"><p class="contentsEntryNumber"><span href="#/chapter06#ch06" title="Link target outside of Sample">
6</span></p>
<p class="contentsEntryName">Ms. Brooks insisted that we keep the treatment’s failure to…</p></div>
<div class="contentsEntry" id="pt_02"><p class="contentsEntryNumber"><span href="#/part02#pt02" title="Link target outside of Sample">
PART 2</span></p>
<p class="contentsEntryName">Ice Age</p></div>
<div class="contentsEntry" id="ch_07"><p class="contentsEntryNumber"><span href="#/chapter07#ch07" title="Link target outside of Sample">
7</span></p>
<p class="contentsEntryName">Over two decades have passed since that fateful day when…</p></div>
<div class="contentsEntry" id="ch_08"><p class="contentsEntryNumber"><span href="#/chapter08#ch08" title="Link target outside of Sample">
8</span></p>
<p class="contentsEntryName">While Halitov and I typically had bad timing and worse…</p></div>
<div class="contentsEntry" id="ch_09"><p class="contentsEntryNumber"><span href="#/chapter09#ch09" title="Link target outside of Sample">
9</span></p>
<p class="contentsEntryName">There was no point in running. We would stand our…</p></div>
<div class="contentsEntry" id="ch_10"><p class="contentsEntryNumber"><span href="#/chapter10#ch10" title="Link target outside of Sample">
10</span></p>
<p class="contentsEntryName">They were killing childern.</p></div>
<div class="contentsEntry" id="ch_11"><p class="contentsEntryNumber"><span href="#/chapter11#ch11" title="Link target outside of Sample">
11</span></p>
<p class="contentsEntryName">Miners across five major colonies on Icillica had organized themselves…</p></div>
<div class="contentsEntry" id="ch_12"><p class="contentsEntryNumber"><span href="#/chapter12#ch12" title="Link target outside of Sample">
12</span></p>
<p class="contentsEntryName">With no time to wrestle the pilot out of his…</p></div>
<div class="contentsEntry" id="pt_03"><p class="contentsEntryNumber"><span href="#/part03#pt03" title="Link target outside of Sample">
PART 3</span></p>
<p class="contentsEntryName">The Blood of Patriots</p></div>
<div class="contentsEntry" id="ch_13"><p class="contentsEntryNumber"><span href="#/chapter13#ch13" title="Link target outside of Sample">
13</span></p>
<p class="contentsEntryName">Ms. Brooks’s face haunted me during the entire trip to…</p></div>
<div class="contentsEntry" id="ch_14"><p class="contentsEntryNumber"><span href="#/chapter14#ch14" title="Link target outside of Sample">
14</span></p>
<p class="contentsEntryName">Had I been in the same room with President Vinnery,…</p></div>
<div class="contentsEntry" id="ch_15"><p class="contentsEntryNumber"><span href="#/chapter15#ch15" title="Link target outside of Sample">
15</span></p>
<p class="contentsEntryName">Paul Beauregard had only wanted to save his mother, but…</p></div>
<div class="contentsEntry" id="ch_16"><p class="contentsEntryNumber"><span href="#/chapter16#ch16" title="Link target outside of Sample">
16</span></p>
<p class="contentsEntryName">I sat in my cell, digging fingers between the regeneration…</p></div>
<div class="contentsEntry" id="ch_17"><p class="contentsEntryNumber"><span href="#/chapter17#ch17" title="Link target outside of Sample">
17</span></p>
<p class="contentsEntryName">President Holtzman had loaned me four of his security officers,…</p></div>
<br/>
<div class="contentsEntry1" id="ack_01"><p class="contentsEntryName"><span href="#/acknowledgments#ack01" title="Link target outside of Sample">
Acknowledgments</span></p></div>
<div class="contentsEntry1" id="ata_01"><p class="contentsEntryName"><span href="#/abouttheauthor#ata01" title="Link target outside of Sample">
About the Author</span></p></div>
<div class="contentsEntry1" id="adc_01"><p class="contentsEntryName"><span href="#/otherbooks#adc01" title="Link target outside of Sample">
Other Books by Ben Weaver</span></p></div>
<div class="contentsEntry1" id="cop_01"><p class="contentsEntryName"><span href="#/copyright#cop01" title="Link target outside of Sample">
Copyright</span></p></div>
<div class="contentsEntry1" id="atp_01"><p class="contentsEntryName"><span href="#/aboutthepublisher#atp01" title="Link target outside of Sample">
About the Publisher</span></p></div>
</div>
<div class="frontMatterPage" id="fm02">
<a id="page08"></a>
<a id="page09"></a>
<div class="chapterHead">
<h2 class="chapterTitle"><span class="bold">Colonial Wardens<br/>Articles of the Code of Conduct<br/>Second Revision 2301<br/>(adopted from 17 System Guard<br/>Corps Operations Manual)</span></h2>
</div>
<div class="chapterBody">
<p class="paraNoIndent"><span class="bold">ARTICLE I</span></p>
<div class="extract">
<p class="extractTextNoIndent">I will always remember that I am a Colonial citizen, fighting in the forces that preserve my world and our way of life. I have resigned to give my life in their defense.</p></div>
<p class="paraNoIndent"><span class="bold">ARTICLE II</span></p>
<div class="extract">
<p class="extractTextNoIndent">I will never surrender of my own volition. If in command, I will never surrender the members of my command while they still have the will and/or means to resist.</p></div>
<p class="paraNoIndent"><span class="bold">ARTICLE III</span></p>
<div class="extract">
<p class="extractTextNoIndent">If I am captured, I will continue to resist by any and all means available. I will make every effort to escape and to aid others to escape. I will accept neither parole nor special favors from the enemy.</p></div>
<p class="paraNoIndent"><span class="bold">ARTICLE IV</span></p>
<div class="extract">
<p class="extractTextNoIndent">If I become a prisoner of war, I will keep faith with my fellow prisoners. I will give no information nor <a id="page10"></a>take part in any action which might be harmful to fellow Colonial citizens.</p></div>
<div class="extract">
<p class="extractTextNoIndent">If I am senior, I will take command. If not, I will obey the lawful orders of those appointed over me and will uphold them in every way.</p></div>
<p class="paraNoIndent"><span class="bold">ARTICLE V</span></p>
<div class="extract">
<p class="extractTextNoIndent">Should I become a prisoner of war, I am required to give name, rank, and willingly submit to retinal and DNA analysis. I will evade answering further questions to the utmost of my ability and will not consciously submit to cerebral scans of any kind. I will make no oral, written, or electronic statements disloyal to the colonies or harmful to their cause.</p></div>
<p class="paraNoIndent"><span class="bold">ARTICLE VI</span></p>
<div class="extract">
<p class="extractTextNoIndent">I will never forget that I am fighting for freedom, that I am responsible for my actions, and that I am dedicated to the principles that make my world free. I will trust in my god or gods and in the Colonial Alliance forever.</p></div></div>
<a id="page11"></a>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// patriotsinarms.vue?158d1c76